// extracted by mini-css-extract-plugin
module.exports = {"EntireRaisedBox":"RaisedBox_EntireRaisedBox__386Gh"};